export const ALL_CSS_PROPERTIES: string[] = [
  '--*',
  'align-content',
  'align-items',
  'align-self',
  'all',
  'animation',
  'animation-delay',
  'animation-direction',
  'animation-duration',
  'animation-fill-mode',
  'animation-iteration-count',
  'animation-name',
  'animation-play-state',
  'animation-timing-function',
  'azimuth',
  'backface-visibility',
  'background-attachment',
  'background-blend-mode',
  'background-clip',
  'background-color',
  'background-image',
  'background-origin',
  'background-position',
  'background-repeat',
  'background-size',
  'background',
  'bleed',
  'border-bottom-color',
  'border-bottom-left-radius',
  'border-bottom-right-radius',
  'border-bottom-style',
  'border-bottom-width',
  'border-bottom',
  'border-collapse',
  'border-color',
  'border-image',
  'border-image-outset',
  'border-image-repeat',
  'border-image-source',
  'border-image-slice',
  'border-image-width',
  'border-left-color',
  'border-left-style',
  'border-left-width',
  'border-left',
  'border-radius',
  'border-right-color',
  'border-right-style',
  'border-right-width',
  'border-right',
  'border-spacing',
  'border-style',
  'border-top-color',
  'border-top-left-radius',
  'border-top-right-radius',
  'border-top-style',
  'border-top-width',
  'border-top',
  'border-width',
  'border',
  'bottom',
  'box-decoration-break',
  'box-shadow',
  'box-sizing',
  'break-after',
  'break-before',
  'break-inside',
  'caption-side',
  'caret-color',
  'clear',
  'clip',
  'color',
  'color-interpolation-filters',
  'columns',
  'column-count',
  'column-fill',
  'column-gap',
  'column-rule',
  'column-rule-color',
  'column-rule-style',
  'column-rule-width',
  'column-span',
  'column-width',
  'content',
  'counter-increment',
  'counter-reset',
  'cue-after',
  'cue-before',
  'cue',
  'cursor',
  'direction',
  'display',
  'elevation',
  'empty-cells',
  'filter',
  'flex',
  'flex-basis',
  'flex-direction',
  'flex-flow',
  'flex-grow',
  'flex-shrink',
  'flex-wrap',
  'float',
  'flood-color',
  'flood-opacity',
  'font-family',
  'font-feature-settings',
  'font-kerning',
  'font-language-override',
  'font-size-adjust',
  'font-size',
  'font-stretch',
  'font-style',
  'font-synthesis',
  'font-variant',
  'font-variant-alternates',
  'font-variant-caps',
  'font-variant-east-asian',
  'font-variant-ligatures',
  'font-variant-numeric',
  'font-variant-position',
  'font-weight',
  'font',
  'gap',
  'grid-area',
  'grid-auto-columns',
  'grid-auto-flow',
  'grid-auto-rows',
  'grid-column-end',
  'grid-column-gap',
  'grid-column-start',
  'grid-column',
  'grid-gap',
  'grid-row-end',
  'grid-row-gap',
  'grid-row-start',
  'grid-row',
  'grid-template-areas',
  'grid-template-columns',
  'grid-template-rows',
  'grid-template',
  'grid',
  'hanging-punctuation',
  'height',
  'hyphens',
  'image-rendering',
  'isolation',
  'justify-content',
  'justify-items',
  'justify-self',
  'left',
  'letter-spacing',
  'lighting-color',
  'line-break',
  'line-height',
  'list-style-image',
  'list-style-position',
  'list-style-type',
  'list-style',
  'margin-bottom',
  'margin-left',
  'margin-right',
  'margin-top',
  'margin',
  'marker-offset',
  'marks',
  'max-height',
  'max-width',
  'min-height',
  'min-width',
  'mix-blend-mode',
  'nav-up',
  'nav-down',
  'nav-left',
  'nav-right',
  'object-fit',
  'object-position',
  'opacity',
  'order',
  'orphans',
  'outline-color',
  'outline-offset',
  'outline-style',
  'outline-width',
  'outline',
  'overflow',
  'overflow-wrap',
  'overflow-x',
  'overflow-y',
  'padding-bottom',
  'padding-left',
  'padding-right',
  'padding-top',
  'padding',
  'page-break-after',
  'page-break-before',
  'page-break-inside',
  'page',
  'pause-after',
  'pause-before',
  'pause',
  'perspective',
  'perspective-origin',
  'pitch-range',
  'pitch',
  'place-content',
  'place-items',
  'place-self',
  'play-during',
  'position',
  'quotes',
  'resize',
  'rest-after',
  'rest-before',
  'rest',
  'richness',
  'right',
  'row-gap',
  'size',
  'speak-header',
  'speak-numeral',
  'speak-punctuation',
  'speak',
  'speech-rate',
  'stress',
  'tab-size',
  'table-layout',
  'text-align',
  'text-align-all',
  'text-align-last',
  'text-combine-upright',
  'text-decoration',
  'text-decoration-color',
  'text-decoration-line',
  'text-decoration-skip',
  'text-decoration-style',
  'text-justify',
  'text-indent',
  'text-orientation',
  'text-overflow',
  'text-shadow',
  'text-transform',
  'text-underline-position',
  'top',
  'transform',
  'transform-box',
  'transform-origin',
  'transform-style',
  'transition',
  'transition-delay',
  'transition-duration',
  'transition-property',
  'transition-timing-function',
  'unicode-bidi',
  'vertical-align',
  'visibility',
  'voice-balance',
  'voice-duration',
  'voice-family',
  'voice-pitch',
  'voice-range',
  'voice-rate',
  'voice-stress',
  'voice-volume',
  'volume',
  'white-space',
  'widows',
  'width',
  'will-change',
  'word-break',
  'word-spacing',
  'word-wrap',
  'writing-mode',
  'z-index',
]
